import React from 'react'
import { Button, ButtonGroup, Dropdown } from 'react-bootstrap'

import styles from './UploadDropDown.module.css'

const UploadDropdown = ({
  onSiteAction,
  onShowCodeEditor,
  onOpenTextEditor,
  disabled,
  viewRepos,
  onOpenUrl,
  onOpenGithubModal,
  onOpenDropBox,
  onOpenTransferRequestLinkModal,
  isMobile
}) => {
  const uploadButton = (
    <Button
      className="flex align-items-center justify-content-center no-box-shadow fs-6 lh-sm"
      variant="primary"
      onClick={() => onSiteAction('CREATE')}
      disabled={disabled}
      data-testid="StyledDropzone-button-upload-file"
    >
      <img className="me-2 ms-1 img" src="/assets/icons/cloud-arrow-up.svg" height={24} alt="" />
      <span className="text">Upload file</span>
    </Button>
  )

  if (isMobile) {
    return <div className={styles.button}>{uploadButton}</div>
  }

  return (
    <Dropdown as={ButtonGroup} className={styles.button}>
      {uploadButton}
      <Dropdown.Toggle
        split
        variant="primary"
        className={`no-box-shadow ${styles.splitToggle}`}
        disabled={disabled}
        style={{ background: '#0359d3' }}
      />
      <Dropdown.Menu className="super-colors">
        <Dropdown.Item className={styles.mobileMenuItem} eventKey="1" onClick={onShowCodeEditor}>
          <img className="me-2 mt-1 opacity-75" src="/assets/icons/code-block.svg" height={16} alt="code-block" />
          <span className="text">Paste HTML</span>
        </Dropdown.Item>
        <Dropdown.Item className={styles.mobileMenuItem} eventKey="2" onClick={onOpenTextEditor}>
          <img className="me-2 mt-1 opacity-75" src="/assets/icons/text.svg" height={16} alt="text" />
          <span className="text">Write text</span>
        </Dropdown.Item>
        <Dropdown.Item
          className={styles.mobileMenuItem}
          eventKey="3"
          onClick={viewRepos ? onOpenGithubModal : onOpenUrl}
        >
          <img className="me-2 mt-1 opacity-75" src="/assets/icons/github.svg" height={16} alt="github" />
          <span className="text">{viewRepos ? 'View Repositories' : 'Deploy from GitHub'}</span>
        </Dropdown.Item>
        <Dropdown.Item className={styles.mobileMenuItem} eventKey="4" onClick={onOpenDropBox}>
          <img className="me-2 mt-1 opacity-75" src="/assets/icons/dropbox.svg" height={16} alt="dropbox" />
          <span className="text">Add Dropbox file</span>
        </Dropdown.Item>
        <Dropdown.Item className={styles.mobileMenuItem} eventKey="5" onClick={onOpenTransferRequestLinkModal}>
          <img
            className="me-2 mt-1 opacity-75"
            src="/assets/icons/transfer-request-link.svg"
            height={16}
            alt="transfer-request-link"
          />
          <span className="text">Create Shared Project</span>
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  )
}

export default UploadDropdown
